import storeFactory from '@/helpers/storeFactory'

export default storeFactory({
  model: {
    event_uuid: null,
    train_number_from: null,
    train_number_to: null,
    location: null
  },
  getters: {
    newItemsCount(state, _, rootState) {
      const trafficMessageModel = rootState.trafficMessage.model
      const turnarounds = trafficMessageModel.turnarounds
      const checkedItems = Object.values(state.data).filter(
        x => x.checked && !x.deleted
      )
      return checkedItems.filter(x => !turnarounds.includes(x.uuid)).length
    },

    missingItemsCount(state, _, rootState) {
      const trafficMessageModel = rootState.trafficMessage.model
      const turnarounds = trafficMessageModel.turnarounds
      const missingItems =
        turnarounds?.filter(
          uuid => state.data[uuid] && !state.data[uuid].checked
        ) || []
      return missingItems.length
    },

    diffItemsCount(state, getters) {
      return getters['newItemsCount'] + getters['missingItemsCount']
    }
  }
})
